<template>
    <TprmModal
        open
        additional-class-name="EntitiesDocumentsModal"
        title="Documents"
        full-screen
        @close="close"
    >
        <SubtleAlert :type="type === 'error' ? 'error' : 'warning'">
            {{ message }}
        </SubtleAlert>
    </TprmModal>
</template>

<style lang="scss">
    .EntitiesDocumentsModal {
        .Modal__content {
            display: flex;
            align-items: center;
            justify-content: center;
            flex: 1;
        }

        .SubtleAlert {
            margin: 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 15px;

            &__icon {
                font-size: 3em;
                margin-right: 0;
                margin-bottom: 0;
            }

            &__message {
                text-align: center;
            }
        }
    }
</style>

<script lang="ts">
    import { Component, Prop, Vue } from '@evidentid/vue-property-decorator';

    import { SubtleAlert } from '@evidentid/dashboard-commons/components/SubtleAlert';

    import TprmModal from '@/components/tprm-modal/TprmModal.vue';

    @Component({
        emits: [ 'close' ],
        components: {
            TprmModal,
            SubtleAlert,
        },
        // PRODUCT-26110 Task 10 (INSTANCE_LISTENERS): `TprmModal`'s own `close` bubbles
        // here and is explicitly re-emitted via `close()` below. Vue 3 merges listeners
        // into `$attrs`, so without `inheritAttrs: false` a caller's `@close` would now
        // ALSO auto-fall-through onto `TprmModal` (the root) as a second listener,
        // double-firing the caller's handler alongside the explicit re-emit. No call
        // site relies on other attrs reaching `TprmModal` (verified: sole usage passes
        // only declared props + `@close`).
        inheritAttrs: false,
    })
    export default class EntitiesDocumentsStatusModal extends Vue {
        @Prop({ type: String, required: true })
        private type!: 'error' | 'warning';

        @Prop({ type: String, required: true })
        private message!: string;

        private close(): void {
            this.$emit('close');
        }
    }
</script>
